export const PatentFoldersService = Symbol.for('PatentFoldersService');
